export default "__VITE_ASSET__ZESqI0RZ__";